import { useEffect, useRef } from "react";
import styles from "./Roadmap.module.css";

const Roadmap = () => {
  const headerRef = useRef(null);
  const timelineBarRef = useRef(null);
  const milestoneRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible);
          }
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -20% 0px" } // 提前 20% 触发
    );

    if (headerRef.current) observer.observe(headerRef.current);
    if (timelineBarRef.current) observer.observe(timelineBarRef.current);
    milestoneRefs.current.forEach((ref) => ref && observer.observe(ref));

    return () => {
      if (headerRef.current) observer.unobserve(headerRef.current);
      if (timelineBarRef.current) observer.unobserve(timelineBarRef.current);
      milestoneRefs.current.forEach((ref) => ref && observer.unobserve(ref));
    };
  }, []);

  const roadmapMilestones = [
    {
      period: "2023-2024: Idea Activation",
      emphasisClass: styles.emphasisText,
      achievements: [
        { text: "Blueprint for the RAYVO (completed)", isCompleted: true },
        { text: "Team building (completed)", isCompleted: true },
        { text: "Idea Testification (completed)", isCompleted: true },
        { text: "Prototype Design and Development (completed)", isCompleted: true },
      ],
    },
    {
      period: "2025Q1: Preparation",
      emphasisClass: styles.emphasisText,
      achievements: [
        { text: "Product Development (completed)", isCompleted: true },
        { text: "Prototype Release", isCompleted: true },
        { text: "Community Building", isCompleted: true },
        { text: "Partnerships and Advisors", isCompleted: true },
      ],
    },
    {
      period: "2025Q2: Seed Round",
      emphasisClass: styles.emphasisText,
      achievements: [
        { text: "1st Gen Product Presale", isCompleted: false },
        { text: "NFT Package Presale", isCompleted: false },
        { text: "Mobile App Launch", isCompleted: false },
        { text: "Airdrops、Events", isCompleted: false },
      ],
    },
    {
      period: "2025Q3-Q4: Strategic Round",
      emphasisClass: styles.emphasisText,
      achievements: [
        { text: "1st Gen Product Deliver", isCompleted: false },
        { text: "Al Agents Platform", isCompleted: false },
        { text: "In-App Marketplace", isCompleted: false },
        { text: "Daily Wear Rewards System Launch", isCompleted: false },
        { text: "Mutil-Channel Market Expansion", isCompleted: false },
      ],
    },
    {
      period: "2026: $RVO IEO",
      emphasisClass: styles.emphasisText,
      achievements: [
        { text: "2nd Gen Product Release", isCompleted: false },
        { text: "Hardware Ecosystem Expansion", isCompleted: false },
        { text: "Marketing and Global Scaling", isCompleted: false },
        { text: "Comprehensive Token Reward System", isCompleted: false },
        { text: "Listing on Exchanges", isCompleted: false },
      ],
    },
  ];

  const Checkbox = ({ isCompleted }) => (
    <div className={`${styles.checkbox} ${isCompleted ? styles.completed : ''}`}>
      {isCompleted && <span className={styles.checkmark}>✓</span>}
    </div>
  );

  return (
    <section className={styles.roadmapSection}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.roadmapLayout}>
            <div id="header" className={styles.roadmapHeader} ref={headerRef}>
              <div className={styles.roadmapTitle}>
                <span className={styles.emphasisText}>
                  Pioneering the future of smart wearables
                </span>
              </div>
              <div className={styles.roadmapDescription}>
                <span>From launching our first-generation smart glasses in 2025 to
                introducing AR/VR capabilities and a decentralized ecosystem by
                2028, we're creating a new era of Web3-powered, data-driven
                experiences.</span>
              </div>
            </div>
            <div id="timeline" className={styles.timelineContainer}>
              <div className={styles.timelineMarker}>
                <div className={styles.markerRing}>
                  <div className={styles.markerDot}></div>
                </div>
              </div>
              <div className={styles.timelineBar}>
                <div className={styles.timelineProgress} ref={timelineBarRef}></div>
              </div>
            </div>
            <div id="milestones" className={styles.milestonesContainer}>
              {roadmapMilestones.map((milestone, index) => (
                <div
                  key={index}
                  className={styles.milestoneItem}
                  ref={(el) => (milestoneRefs.current[index] = el)}
                >
                  <span className={styles.milestonePeriod}>
                    <div className={milestone.emphasisClass}>{milestone.period}</div>
                  </span>
                  <div className={styles.milestoneDetails}>
                    {milestone.achievements.map((achievement, i) => (
                      <div key={i} className={styles.achievementItem}>
                        <Checkbox isCompleted={achievement.isCompleted} />
                        <span className={styles.achievementText}>
                          {achievement.text}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
